export default {
  viewport: '',
  width: 0,
  height: 0,
  // maximum pixel width for each
  breakpoints: {
    xs: 768,
    sm: 1440,
    md: 1920,
  },
  scroll: {
    x: undefined,
    y: undefined,
  },
};
